module.exports = __webpack_public_path__ + "static/img/banner1.542ed23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/banner1.jpg
// module id = tJe7
// module chunks = 1